var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollargreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E8F6ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.6667C29.7907 26.6667 28 27.86 28 29.3333C28 30.8067 29.7907 32 32 32C34.2093 32 36 33.1933 36 34.6667C36 36.14 34.2093 37.3333 32 37.3333M32 26.6667C33.48 26.6667 34.7733 27.2027 35.4653 28M32 26.6667V25.3333M32 26.6667V37.3333M32 37.3333V38.6667M32 37.3333C30.52 37.3333 29.2267 36.7973 28.5347 36M44 32C44 33.5759 43.6896 35.1363 43.0866 36.5922C42.4835 38.0481 41.5996 39.371 40.4853 40.4853C39.371 41.5996 38.0481 42.4835 36.5922 43.0866C35.1363 43.6896 33.5759 44 32 44C30.4241 44 28.8637 43.6896 27.4078 43.0866C25.9519 42.4835 24.629 41.5996 23.5147 40.4853C22.4004 39.371 21.5165 38.0481 20.9134 36.5922C20.3104 35.1363 20 33.5759 20 32C20 28.8174 21.2643 25.7652 23.5147 23.5147C25.7652 21.2643 28.8174 20 32 20C35.1826 20 38.2348 21.2643 40.4853 23.5147C42.7357 25.7652 44 28.8174 44 32Z",
    stroke: "url(#paint0_linear_2541_10350)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2541_10350",
    x1: 32,
    y1: 20,
    x2: 32,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollargreen);
export default __webpack_public_path__ + "static/media/dollar green.df38cd2d55cae6b8f63ff5fd82cb7ebd.svg";
export { ForwardRef as ReactComponent };